import { Form, NavLink, useRouteLoaderData } from "react-router-dom";

import classes from "./MainNavigation.module.css";
import logo from "../logo.png";

function MainNavigation() {
  const isAuthenticated = useRouteLoaderData("root");

  return (
    <header className={classes.header}>
      <nav>
        <div className={classes.logoContainer}>
          <img src={logo} alt="Logo" width="200" height="30" />
        </div>
      </nav>
      <nav>
        <ul className={classes.list}>
          {!isAuthenticated && (
            <li>
              <NavLink
                to="/login"
                className={({ isActive }) =>
                  isActive ? classes.active : undefined
                }
              >
                Login
              </NavLink>
            </li>
          )}
          

          {isAuthenticated && (
            <Form action="/logout" method="post">
              <button>Logout</button>
            </Form>
          )}
        </ul>
      </nav>
    </header>
  );
}

export default MainNavigation;
